import store from '@/store';
import { CODE_ENV_LIST } from '@/common/constants/ConstCode';
import { nativeShareText } from '@/common/utils/module/NativeRequest';
import { showTextModal } from '@/common/utils/ModalState';
import { getCurrentPath, isIPad, isIPhone } from '@/common/utils/Util';

export const funeralShare = () => {
  const funeral = store.getters['funeral/getDetail']; // 온라인 장례식장 정보

  const form = `[Life END Life] \n\n${funeral.deadName}님의 온라인 장례식장으로 모십니다. \n링크 : ${
    CODE_ENV_LIST.DYNAMIC_DOMAIN
  }/${getCurrentPath()}`;

  nativeShareText(form);
  navigator.clipboard.writeText(form).then(() => {
    if (!isIPhone() && !isIPad()) {
      showTextModal('현재 온라인 장례식장 내용이 복사되었습니다.', '확인');
    }
  });
};

export const funeralKakaoShare = () => {
  const funeral = store.getters['funeral/getDetail']; // 온라인 장례식장 정보

  Kakao.Share.createDefaultButton({
    container: '#kakaotalk-sharing-btn',
    objectType: 'feed',
    content: {
      title: `${funeral.deadName}님의 온라인 장례식장으로 모십니다.`,
      imageUrl: `${CODE_ENV_LIST.FILE_SERVER_URL}/origin/backgroundImage/flower/33.jpg`,
      link: {
        webUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/funeral/info/${funeral.funeralNo}`,
        mobileWebUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/funeral/info/${funeral.funeralNo}`
      }
    },
    itemContent: {
      profileText: 'Life END Life',
      profileImageUrl: `${CODE_ENV_LIST.FILE_SERVER_URL}/origin/AppIcon.png?v=2`
    },
    buttons: [
      {
        title: '확인하기',
        link: {
          webUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/funeral/info/${funeral.funeralNo}`,
          mobileWebUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/funeral/info/${funeral.funeralNo}`
        }
      }
    ]
  });
};
